import React from 'react';
import { Icon, Link, LinkAdapter } from '@gaiads/telia-react-component-library';

import styles from './Cart.module.scss';

export type CartProps = {
  /** Link where user is redirected after clicking on the cart */
  link: string;
  /** Number of items in cart */
  amount?: number;
  /** Aria label for the cart link */
  linkAriaLabel: string;
  /** Custom link or for injecting third party routing link */
  linkAdapter?: LinkAdapter;
};

const Cart: React.FunctionComponent<CartProps> = ({ link, amount, linkAriaLabel, linkAdapter }: CartProps) => {
  return (
    <Link className={styles.cart} to={link} aria-label={linkAriaLabel} linkAdapter={linkAdapter}>
      <Icon name="cart" size="lg" color="black" />

      {amount && amount > 0 ? (
        <div className={styles.cart_amount}>
          <svg className={styles.cart_amountIcon} xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="50" fill="#fff" />
            <circle cx="50" cy="50" r="40" fill="#990ae3" />
          </svg>

          <div className={styles.cart_amountNumber}>{amount}</div>
        </div>
      ) : null}
    </Link>
  );
};

export default Cart;
